"use strict";
function isPromise(value) {
    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
exports.isPromise = isPromise;
//# sourceMappingURL=isPromise.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/submit text project/gwin/~/._rxjs@5.4.3@rxjs/util/isPromise.js
// module id = ../../../../._rxjs@5.4.3@rxjs/util/isPromise.js
// module chunks = 5